import React from "react";
import FadeOutErrorMessage from "../../commonComponents/util/FadeOutErrorMessage";
import LoadingSpinner from "../../commonComponents/util/LoadingSpinner";
import Modal from "../../commonComponents/util/Modal";

export default class TransactionNoteModal extends React.Component {
  state = {
    error: false,
    text: ""
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.text !== this.props.text) {
      this.setState({ text: nextProps.text || "" });
    }
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onClose = () => {
    this.props.close();
    this.setState({ 
      error: false,
      text: "" 
    });
  };

  onSave = async () => {
    const { save, saveAsync } = this.props;

    if (saveAsync) {
      this.setState({ error: false });

      await saveAsync(this.state.text);
      
      if (this.props.success) {
        this.onClose();
      } else {
        this.setState({ error: true });
      }
    } else {
      save(this.state.text);
      this.onClose();
    }
  };

  render() {
    const { loading, text: initialText } = this.props;
    const { error, text } = this.state;

    return (
      <Modal modalShowing={this.props.show}>
        <div className="modal-container">
          <div className="modal warning-modal">
            <div className="modal-header">
              <h4 className="page-header">
                {initialText ? "Edit" : "New"} Reconciliation Note
              </h4>
              <i
                className="icon ion-ios-close-empty"
                onClick={this.onClose.bind(this)}
              />
            </div>
            <textarea value={text} name="text" onChange={this.onChange} />

            {loading ? (
              <LoadingSpinner height="20" alignRight={true} />
            ) : (
              <div className="modal-btns text-right">
                <button className="btn btn-accent" onClick={this.onClose}>
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={(!text && !initialText) || text === initialText}
                  onClick={this.onSave}
                >
                  Save
                </button>
                <FadeOutErrorMessage show={error} />
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/TransactionNoteModal.jsx